import { render, staticRenderFns } from "./EventDashboard.vue?vue&type=template&id=42afd300&scoped=true&"
import script from "./EventDashboard.vue?vue&type=script&lang=js&"
export * from "./EventDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42afd300",
  null
  
)

export default component.exports